import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import ProjectsGrid from '../components/ProjectsGrid';
import AboutSection from '../components/AboutSection';
import BrandsCarousel from '../components/BrandsCarousel';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Hero />
      <ServicesSection />
      <ProjectsGrid />
      <AboutSection />
      <BrandsCarousel background="bg-surface" />
      <ContactSection />
    </>
  );
};

export default Home;
